/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import * as PushUtils            from 'lib/PushUtils';
import * as PushConstants        from 'dashboard/Push/PushConstants';
import Icon                      from 'components/Icon/Icon.react';
import prettyNumber              from 'lib/prettyNumber';
import PropTypes                 from 'prop-types';
import RadioButton               from 'components/RadioButton/RadioButton.react';
import React                     from 'react';
import styles                    from 'components/PushAudiencesSelector/PushAudiencesOption.scss';
import { yearMonthDayFormatter } from 'lib/DateUtils';
import PushAudiencesBaseRow      from 'components/PushAudiencesSelector/PushAudiencesBaseRow.react';

const FORM_PREFIX = 'audience_radio';

const AUDIENCE_SIZE_FETCHING_ENABLED = true;
const AUDIENCE_CREATED_DATE_ENABLED = true;

export default class PushAudiencesOption extends PushAudiencesBaseRow {
  constructor(props) {
    super();
    this.state = {
      loading: true,
      count: undefined,
      current: false,
      approximate: false,
      isNewSegment: false,
      availableDevices: props.availableDevices
    }
  }

  handleChange() {
    if(this.props.onChange && !this.props.isDisabled){
      this.props.onChange.call(undefined, this.state.count);
    } else {
      return;
    }
  }

  // pass count information to PushNew flow
  componentWillUpdate(nextProps, nextState) {
    if ((nextState.count !== this.state.count || JSON.stringify(nextProps.query) !== JSON.stringify(this.props.query))
      && this.props.isChecked) {
      nextProps.onChange.call(undefined, nextState.count);
    }
  }

  renderplatformsInfo() {
    //TODO @pivanov: need to refactor this shit
    let platformsInfo = []

    let availableDevices = this.props.availableDevices;
    let availablePlatforms = this.props.query ? this.props.query.deviceType['$in'].sort() : false;

    let arr = []

    for (let i = 0; i < availableDevices.length; i++) {
      let exist = this.props.id == 'everyone' ? true : false

      for (let x = 0; x < availablePlatforms.length; x++) {
        if (availableDevices[i] == availablePlatforms[x]) {
          exist = true
        }
      }

      arr[i] = { "icon" : [availableDevices[i], exist] };
    }


    for (let item in arr) {
      let showIcon = arr[item].icon[1] ? '' : '-disabled'

      platformsInfo.push(
        <div key={Math.random().toString(36).substr(2, 5)} className={styles.icon}>
          <Icon width={24} height={24} key={this.props.id} name={'icon-logo-' + arr[item].icon[0] + showIcon} colored={true} />
        </div>
      );
    }

    return <div className={[styles.cell, styles.col4].join(' ')}>{platformsInfo}</div>;
  }

  render() {
    let inputId=[FORM_PREFIX, this.props.id].join('_');

    let conditions = PushUtils.largeInfoBuilder(this.props.query, this.props.schema, styles);
    let detailsView = null;

    if (conditions) {
      detailsView = this.state.expandedView ?
        <div className={styles.info}>{conditions}</div> : null
    }

    return (
      <label key={Math.random().toString(36).substr(2, 5)} key={inputId} htmlFor={inputId} className={[styles.row, this.state.expandedView ? styles.show: '', this.props.isChecked ? styles.current : ''].join(' ')}>
        <div>
          <div className={[styles.cell, styles.col1].join(' ')}>
            <RadioButton
              id={inputId}
              name={FORM_PREFIX}
              className={styles.input}
              // parentClassName={styles.radiobutton}
              onChange={this.handleChange.bind(this)}
              checked={this.props.isChecked}
              disabled={this.props.isDisabled}/>
            <div className={styles.audienceInfo}>
              <span style={ this.props.icon ? { verticalAlign: 'top', paddingLeft: 5 } : {} }>{this.props.name}</span>
            </div>
          </div>

          {AUDIENCE_SIZE_FETCHING_ENABLED ? <div className={[styles.cell, styles.col2].join(' ')}>
            {PushUtils.formatCountDetails(this.state.count, this.state.approximate)}
          </div> : null}
          {AUDIENCE_CREATED_DATE_ENABLED ? <div className={[styles.cell, styles.col3].join(' ')}>
            {yearMonthDayFormatter(this.props.createdAt)}
          </div> : null}

          {this.renderplatformsInfo()}

          <div className={[styles.cell, styles.col5].join(' ')}>
            {
              this.state.isNewSegment
              ? <a
                  role='button'
                  className={[styles.moreDetails, !this.props.query ? styles.hideMoreDetails : ''].join(' ')}
                  href='javascript:;'
                  onClick={this.props.onEditAudience.bind(undefined, {
                    name: this.props.name,
                    filters: this.props.filters,
                    query: this.props.query,
                  })}>
                  <Icon width={14} height={14} name={'icon-pencil'} />
                </a>
              : <a
                  role='button'
                  className={[styles.moreDetails, !conditions ? styles.missingConditions : '' ,!this.props.query ? styles.hideMoreDetails : ''].join(' ')}
                  href='javascript:;'
                  onClick={this.handleDetailsToggle.bind(this,this.props.query, this.props.schema)}>
                  {this.state.isNewSegment}
                  {this.state.expandedView
                    ? <Icon width={14} height={14} name={'icon-eye-slash'} />
                    : <Icon width={14} height={14} name={'icon-eye'} />
                  }
                </a>
            }
          </div>
        </div>

        {detailsView}
      </label>
    );
  }
}

PushAudiencesOption.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  createdAt: PropTypes.instanceOf(Date),
  availableDevices: PropTypes.array,
  query: PropTypes.object,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  schema: PropTypes.object,
  onEditAudience: PropTypes.func.isRequired,
};
